// @ts-strict-ignore
import {getReportName} from './index';

const FEATURE_GATE_NAME_TO_FRIENDLY_NAME = {
  ab_testing: `A/B Testing`,
  alerts: `Alerts`,
  alerts_limit: `Alerts`,
  bookmark: `Saved Reports`,
  campaign: `Campaign`,
  cohorts: `Cohorts`,
  csv: `CSV Export`,
  custom_events: `Custom Events`,
  date_picker: `Data History`,
  data_management: `Data Management`,
  data_pipelines: `Data Pipelines`,
  'experiment-reporting': `Experiment Reporting`,
  flows: `Flows`,
  formulas: `Formulas`,
  funnels: `Funnels`,
  impact: `Impact`,
  jql_console: `JQL Console`,
  lookup_tables: `Lookup Tables`,
  messages: `Messages`,
  saved_metrics: `Saved Metrics`,
  oda: `On Demand Analysis`,
  platform: `Custom Apps`,
  retention: `Retention`,
  revenue: `Revenue`,
  sampling: `Sampling`,
  sharing: `Sharing`,
  security: `Two-Factor/SSO`,
  segmentation: `Segmentation`,
  signal: `Signal`,
  spark: `Spark`,
  team: `Team Members`,
  visual_journeys: `Visual Journeys`,
};

const FEATURE_GATE_NAME_TO_LIMIT_TYPE = {
  ab_testing: `Feature Access`,
  alerts: `Feature Access`,
  alerts_limit: `Feature Limit`,
  bookmark: `Feature Limit`,
  campaign: `Feature Access`,
  cohorts: `Feature Access`,
  csv: `Feature Access`,
  custom_events: `Feature Limit`,
  date_picker: `Feature Limit`,
  data_management: `Feature Access`,
  data_pipelines: `Feature Access`,
  'experiment-reporting': `Feature Access`,
  events: `Feature Limit`,
  flows: `Feature Access`,
  formulas: `Feature Access`,
  funnels: `Feature Limit`,
  impact: `Feature Access`,
  jql_console: `Feature Access`,
  lookup_tables: `Feature Access`,
  messages: `Feature Access`,
  oda: `Feature Access`,
  platform: `Feature Access`,
  retention: `Feature Limit`,
  revenue: `Feature Access`,
  sampling: `Feature Access`,
  saved_metrics: `Feature Access`,
  security: `Feature Access`,
  segmentation: `Feature Limit`,
  signal: `Feature Access`,
  team: `Feature Limit`,
  visual_journeys: `Feature Access`,
};

export enum UpsellType {
  FREE_TO_GROWTH = `Free to Growth`,
  GROWTH_TO_ENTERPRISE = `Growth to Enterprise`,
  UNKNOWN = `Unknown`,
}

interface EventMetadata {
  version?: string;
  upsellType?: UpsellType;
}

export function trackUpsellEvent(eventName: string, featureGateType: string, metadata?: EventMetadata) {
  const defaultMetadata: EventMetadata = {
    version: `v1`,
    upsellType: UpsellType.UNKNOWN,
  };

  const parsedMetadata = {
    ...defaultMetadata,
    ...metadata,
  };

  mixpanel.track(eventName, {
    Tab: getReportName(),
    'Feature Limit': FEATURE_GATE_NAME_TO_FRIENDLY_NAME[featureGateType],
    'Limit Type': FEATURE_GATE_NAME_TO_LIMIT_TYPE[featureGateType],
    Version: parsedMetadata.version,
    'Upsell Type': parsedMetadata.upsellType,
  });
}
